<template>
    <div :class="['page contact',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false;" />
        <div class="page-content">
            <img class="page-image" src="/contact.png" />
            <div class="div-btns" :style="{ position: 'absolute', top: '0px', left: '0px' }">
                <input placeholder="Enter your name" style="position: absolute;top:270px;left:25px;width: 310px;" />
                <input placeholder="Enter your email address" style="position: absolute;top:355px;left:25px;width: 310px;" />
                <input placeholder="Your Message..." style="position: absolute;top:430px;left:25px;width: 310px;" />
                <p @click="send" style="position: absolute;top:550px;left:20px;width: 340px;height: 90px;background-color: rgba(200,0,0,0);"></p>
            </div>
            <!--
            <h1>CONTACT US</h1>
            <input placeholder="Enter you email address" />
            <textarea placeholder="Enter your message here...."></textarea>
            <p class="btn lg">SEND MESSAGE</p>
            -->
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'

export default {
    name: 'contact',
    mixins: [ pageOn ],
    components: {
        VHeader
    },
    mounted () {
        var width = parseInt(getComputedStyle(this.$el.querySelector('.page-content')).width);
        this.$el.querySelector('.div-btns').style.transform = 'scale('+( width / 414 )+')';
    },
    methods: {
        send () {
            console.log('send...');
        }
    }
}

</script>

<style lang="scss">
.contact {
    h1,h2 { font-weight: 300; text-align: center; }
    h1 { color: $font-color; margin-top: 30px; }
    input { width: calc(100% - 50px); }
    textarea {
        width: calc(100% - 50px);
        margin: 10px 15px;
        min-height: 300px;
        font-size: 20px;
        padding: 10px;
    }
}
</style>